import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export interface IntuiAspectRatioProps {
  /** Aspect ratio as a number (e.g., 16/9, 4/3, 1) */
  ratio?: number
  children: ReactNode
  className?: string
}

/**
 * Figma (node 28:1669): overflow-clip relative, children absolute inset-0 object-cover size-full.
 * Supports ratios: 1/1, 4/3, 3/4, 16/9, 9/16, 3/2, 2/3, 16/10, 21/9, etc.
 */
function IntuiAspectRatio({ ratio = 16 / 9, children, className }: IntuiAspectRatioProps) {
  return (
    <div className={cn('relative w-full overflow-clip', className)} style={{ paddingBottom: `${(1 / ratio) * 100}%` }}>
      <div className="absolute inset-0 [&>img]:object-cover [&>img]:size-full">{children}</div>
    </div>
  )
}

export { IntuiAspectRatio }
